var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProjectsWithBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#D8E6FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 6.75C7.31421 6.75 6.75 7.31421 6.75 8V10C6.75 10.6858 7.31421 11.25 8 11.25H11C11.6858 11.25 12.25 10.6858 12.25 10V8C12.25 7.31421 11.6858 6.75 11 6.75H8ZM5.25 8C5.25 6.48579 6.48579 5.25 8 5.25H11C12.5142 5.25 13.75 6.48579 13.75 8V10C13.75 11.5142 12.5142 12.75 11 12.75H8C6.48579 12.75 5.25 11.5142 5.25 10V8Z",
    fill: "#1570EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2 7.75C20.9542 7.75 20.75 7.95421 20.75 8.20001V9.79999C20.75 10.0458 20.9542 10.25 21.2 10.25H24.8C25.0458 10.25 25.25 10.0458 25.25 9.79999V8.20001C25.25 7.95421 25.0458 7.75 24.8 7.75H21.2ZM19.25 8.20001C19.25 7.12581 20.1258 6.25 21.2 6.25H24.8C25.8742 6.25 26.75 7.12581 26.75 8.20001V9.79999C26.75 10.8742 25.8742 11.75 24.8 11.75H21.2C20.1258 11.75 19.25 10.8742 19.25 9.79999V8.20001Z",
    fill: "#1570EF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2 15.25C20.9542 15.25 20.75 15.4542 20.75 15.7V17.3C20.75 17.5458 20.9542 17.75 21.2 17.75H24.8C25.0458 17.75 25.25 17.5458 25.25 17.3V15.7C25.25 15.4542 25.0458 15.25 24.8 15.25H21.2ZM19.25 15.7C19.25 14.6258 20.1258 13.75 21.2 13.75H24.8C25.8742 13.75 26.75 14.6258 26.75 15.7V17.3C26.75 18.3742 25.8742 19.25 24.8 19.25H21.2C20.1258 19.25 19.25 18.3742 19.25 17.3V15.7Z",
    fill: "#1570EF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.25 9C12.25 8.58579 12.5858 8.25 13 8.25H20C20.4142 8.25 20.75 8.58579 20.75 9C20.75 9.41421 20.4142 9.75 20 9.75H13C12.5858 9.75 12.25 9.41421 12.25 9Z",
    fill: "#1570EF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 8.25C16.9142 8.25 17.25 8.58579 17.25 9V22C17.25 22.6858 17.8142 23.25 18.5 23.25H20C20.4142 23.25 20.75 23.5858 20.75 24C20.75 24.4142 20.4142 24.75 20 24.75H18.5C16.9858 24.75 15.75 23.5142 15.75 22V9C15.75 8.58579 16.0858 8.25 16.5 8.25Z",
    fill: "#1570EF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.75 16.5C15.75 16.0858 16.0858 15.75 16.5 15.75H20C20.4142 15.75 20.75 16.0858 20.75 16.5C20.75 16.9142 20.4142 17.25 20 17.25H16.5C16.0858 17.25 15.75 16.9142 15.75 16.5Z",
    fill: "#1570EF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2 22.75C20.9542 22.75 20.75 22.9542 20.75 23.2V24.8C20.75 25.0458 20.9542 25.25 21.2 25.25H24.8C25.0458 25.25 25.25 25.0458 25.25 24.8V23.2C25.25 22.9542 25.0458 22.75 24.8 22.75H21.2ZM19.25 23.2C19.25 22.1258 20.1258 21.25 21.2 21.25H24.8C25.8742 21.25 26.75 22.1258 26.75 23.2V24.8C26.75 25.8742 25.8742 26.75 24.8 26.75H21.2C20.1258 26.75 19.25 25.8742 19.25 24.8V23.2Z",
    fill: "#1570EF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectsWithBg);
export default __webpack_public_path__ + "static/media/projects-with-bg.5f4eac3d5f7bdc600e611b50bed14827.svg";
export { ForwardRef as ReactComponent };